// export const apiUrl = 'http://192.168.1.201:8000/apis/';
// export const assetsUrl = 'http://192.168.1.201:8000/apis/';

// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/assets/';

export const apiUrl = 'https://demo.svuzoologyalumni.com/apibackend/apis/';
export const assetsUrl = 'https://demo.svuzoologyalumni.com/apibackend/assets/';